<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-size-75">
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-primary">
            <div class="card-icon">
              <md-icon>{{ statInspIcon }}</md-icon>
            </div>
          </md-card-header>
          <md-card-content>
            <div class="md-layout">
              <label class="md-layout-item md-form-label">Search:</label>
              <div class="md-layout-item md-size-50">
                <md-field>
                  <md-input
                    type="search"
                    clearable
                    placeholder="e.g. site name, building name/address or serial no"
                    v-model="searchCriteria.searchText"
                    @keydown.enter.native="searchStatInsps()"
                  ></md-input>
                  <md-button
                    class="md-icon-button md-primary"
                    @click="searchStatInsps()"
                  >
                    <md-icon>search</md-icon>
                  </md-button>
                </md-field>
              </div>
            </div>
            <md-table
              v-model="statInsps.items"
              class="table-striped"
              table-header-color="primary"
            >
              <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="Serial No">
                  <router-link
                    :to="{
                      name: 'Statutory Inspection',
                      params: { statInspId: item.id }
                    }"
                  >
                    {{ item.serialNo }}
                  </router-link>
                </md-table-cell>
                <md-table-cell md-label="Location">
                  {{ item.location }}
                </md-table-cell>
                <md-table-cell md-label="Next Report Date">
                  {{ item.nextReportDate | moment("dddd, MMMM Do YYYY") }}
                </md-table-cell>
                <md-table-cell md-label="Building Address">
                  {{ item.buildingAddress }}
                </md-table-cell>
                <md-table-cell>
                  <span class="badge badge-danger" v-show="item.isOverdue"
                    >Overdue</span
                  >
                  <span
                    class="badge badge-warning"
                    v-show="item.isExpired && !item.isOverdue"
                    >Expired</span
                  >&nbsp;
                  <span class="badge badge-default" v-show="item.isPartial"
                    >Part/Non</span
                  >
                </md-table-cell>
              </md-table-row>
              <md-table-empty-state
                md-label="No Statutory Inspections Found"
              ></md-table-empty-state>
            </md-table>
          </md-card-content>
          <md-card-actions md-alignment="space-between">
            <div class>
              <p class="card-category">
                Showing {{ from + 1 }} to {{ to }} of {{ total }} Statutory
                Inspections
              </p>
            </div>
            <pagination
              class="pagination-no-border pagination-default"
              v-model="searchCriteria.currentPage"
              :per-page="searchCriteria.itemsPerPage"
              :total="statInsps.total"
            ></pagination>
          </md-card-actions>
        </md-card>
      </div>
      <div class="md-layout-item md-medium-size-100 md-size-25">
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-primary">
            <div class="card-icon">
              <md-icon>find_in_page</md-icon>
            </div>
            <h4 class="title">Filters</h4>
          </md-card-header>
          <md-card-content>
            <md-field>
              <label for="contractorRegion">Contractor</label>
              <md-select
                v-model="filterCriteria.contractorRegionId"
                name="contractorRegion"
                id="contractorRegion"
                @md-selected="onFilterChange"
              >
                <md-option value="0">All</md-option>
                <md-option
                  v-for="contractorRegion in permittedContractorRegions"
                  :key="contractorRegion.id"
                  :value="contractorRegion.id"
                >
                  {{ contractorRegion.name }}
                </md-option>
              </md-select>
            </md-field>
            <md-field>
              <label for="statInspStatus">Status</label>
              <md-select
                v-model="filterCriteria.statInspStatusId"
                name="statInspStatus"
                id="statInspStatus"
                @md-selected="onFilterChange"
              >
                <md-option :value="0">All</md-option>
                <md-option :value="3">Overdue</md-option>
                <md-option :value="2">Expired</md-option>
                <md-option :value="1">Active</md-option>
              </md-select>
            </md-field>
          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Pagination } from "@/components";

export default {
  components: {
    Pagination
  },
  data() {
    return {
      filterCriteria: {
        contractorRegionId: "0",
        statInspStatusId: 0
      },
      searchCriteria: {
        searchText: undefined,
        currentPage: 1,
        itemsPerPage: 15
      }
    };
  },
  computed: {
    ...mapGetters({
      statInspIcon: "stat-insp/icon",
      statInsps: "stat-insp/statInsps"
    }),
    permittedContractorRegions() {
      return this.$auth.profile.contractorRegions;
    },
    to() {
      let highBound = this.from + this.searchCriteria.itemsPerPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return (
        this.searchCriteria.itemsPerPage * (this.searchCriteria.currentPage - 1)
      );
    },
    total() {
      return this.statInsps.total;
    }
  },
  async created() {
    this.$route.query.contractorRegionId !== undefined
      ? (this.filterCriteria.contractorRegionId = this.$route.query.contractorRegionId)
      : "0";
    this.$route.query.statInspStatusId !== undefined
      ? (this.filterCriteria.statInspStatusId = this.$route.query.statInspStatusId)
      : 0;
    await this.getStatInsps();
  },
  methods: {
    async onFilterChange() {
      await this.getStatInsps();
    },
    async searchStatInsps() {
      await this.getStatInsps();
    },
    async getStatInsps() {
      this.$store.dispatch("stat-insp/getStatInspListing", {
        filterCriteria: this.filterCriteria,
        searchCriteria: this.searchCriteria
      });
    }
  },
  watch: {
    async from() {
      await this.getStatInsps();
    }
  }
};
</script>

<style></style>
